import React from 'react';
import classNames from 'classnames';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';

import style from '../product.module.scss';
import styleVariation from './ProductCardBtnBottomHover.module.scss';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

const ProductCardBtnBottomHover: React.FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
  onKiosk,
  onKioskAddClicked,
  isAddToCartInKioskDisabled,
}) => {
  const { product, isSpecial, variants, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      isInternalWrapper
      onKiosk={onKiosk}
      product={product}
    >
      <div className={styleVariation.product__image_container}>
        <ProductImage
          className={styleVariation.product__image}
          product={product}
        />
        <div
          aria-label="Product actions"
          className={styleVariation.actions__body}
          role="group"
        >
          <ProductActionFavorite
            className={classNames(
              style.favorite_action,
              styleVariation.favorite__button,
            )}
            product={product}
          />
        </div>
        <ProductBadgeContainer
          className={styleVariation.product__badges_container}
          onKiosk={onKiosk}
          product={product}
          weightVariant={weightVariant}
        />
      </div>
      <div
        className={classNames(
          style.product__body,
          styleVariation.product__body,
        )}
      >
        <ProductName name={product?.name || NOT_DEFINED} />
        <ProductInfoCarousel
          className={styleVariation.variation__info_carousel}
        >
          {availableInfo}
        </ProductInfoCarousel>
        <div
          className={classNames(styleVariation.product__actions_footer, {
            [styleVariation.product__actions_footer_largue_card]: isLargeCard,
            [styleVariation.product__actions_footer_kiosk]: onKiosk,
          })}
        >
          <ProductPrice
            className={classNames(styleVariation.product__price, {
              [styleVariation.product__price_kiosk]: onKiosk,
            })}
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="column-container"
            weightVariant={weightVariant}
          />
          {onKiosk && isAddToCartInKioskDisabled ? null : (
            <Counter
              actionTheme="primary"
              className={classNames(styleVariation.actions__counter_hover, {
                [styleVariation.actions__counter_hover_largue_card]:
                  isLargeCard,
                [styleVariation.actions__counter_hover_kiosk]: onKiosk,
              })}
              onCard
              onKiosk={onKiosk}
              onKioskAddClicked={onKioskAddClicked}
              product={product}
              selectedWeightVariant={weightVariant}
              showIcon
            />
          )}
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardBtnBottomHover };
